(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('Coupon', Coupon);

    Coupon.$inject = ['$resource', 'DateUtils'];

    function Coupon ($resource, DateUtils) {
        var resourceUrl =  'api/coupons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFromDate = DateUtils.convertDateTimeFromServer(data.validFromDate);
                        data.validToDate = DateUtils.convertDateTimeFromServer(data.validToDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'apply' : { method:'GET', url: 'api/coupons/apply/:couponCode/:quoteId' },
            'removeFromQuote' : { method:'PUT', url: 'api/coupons/remove-from-quote/:quoteId'}
        });
    }
})();
